import axios from "axios";

import { BASEURL } from "../../../constants/const";
import { encryptStorage } from "../../../constants/EncryptStorage";

export function ApiNisabReport() {
  const userToken = encryptStorage.getItem("token");
  const headers = { Authorization: `Bearer ${userToken}` };
  const authAxios = axios.create({ baseURL: BASEURL, headers });
  const fileAxios = axios.create({ baseURL: BASEURL, headers, responseType: "arraybuffer" });
  const url = BASEURL + "nisabreport/";

  return {
    GetReport: (filter) => authAxios.post(url + "GetRafiqWiseNisabReport/", filter),
    GetDetail: (request) => authAxios.post(url + "GetRafiqNisabDetail/", request),
    GetExcel: (filter) => fileAxios.post(url + "GetRafiqWiseNisabExcelReport/", filter),
    GetPdf: (filter) => fileAxios.post(url + "GetRafiqWiseNisabPdfReport/", filter),
  };
}
